import AbstractDeviceSetup from "../all/AbstractDeviceSetup";
import LGWeb0s from '../../utils/LGWeb0s';

class Web0sDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }

  setup() {
    return new Promise( (resolve) => {
      new LGWeb0s();
      resolve();
    });
  }
}

export default Web0sDeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/web0s/DeviceSetup.js